export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9182.85573bf6.jpg";